// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import ActivityCardController from "./activity_card_controller"
application.register("activity-card", ActivityCardController)

import PriorityDndController from "./priority_dnd_controller"
application.register("priority-dnd", PriorityDndController)

import ActivityEditRowController from "./activity_edit_row_controller"
application.register("activity-edit-row", ActivityEditRowController)

import ActivityExclusionPairsController from "./activity_exclusion_pairs_controller"
application.register("activity-exclusion-pairs", ActivityExclusionPairsController)

import ActivityPickerController from "./activity_picker_controller"
application.register("activity-picker", ActivityPickerController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AuditRowController from "./audit_row_controller"
application.register("audit-row", AuditRowController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import BulkToggleController from "./bulk_toggle_controller"
application.register("bulk-toggle", BulkToggleController)

import ClipboardCopyController from "./clipboard_copy_controller"
application.register("clipboard-copy", ClipboardCopyController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import CodeSelectController from "./code_select_controller"
application.register("code-select", CodeSelectController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import ActivityFilterController from "./activity_filter_controller"
application.register("activity-filter", ActivityFilterController)

import CalendarSelectController from "./calendar_select_controller"
application.register("calendar-select", CalendarSelectController)

import CascadeOrderController from "./cascade_order_controller"
application.register("cascade-order", CascadeOrderController)

import TierWeightMapController from "./tier_weight_map_controller"
application.register("tier-weight-map", TierWeightMapController)

import ChatbotShowcaseController from "./chatbot_showcase_controller"
application.register("chatbot-showcase", ChatbotShowcaseController)

import ChatPanelController from "./chat_panel_controller"
application.register("chat-panel", ChatPanelController)

import CompensationDaysController from "./compensation_days_controller"
application.register("compensation-days", CompensationDaysController)

import CompensationStrategyController from "./compensation_strategy_controller"
application.register("compensation-strategy", CompensationStrategyController)


import EligibleStaffFilterController from "./eligible_staff_filter_controller"
application.register("eligible-staff-filter", EligibleStaffFilterController)

import ExchangeSelectController from "./exchange_select_controller"
application.register("exchange-select", ExchangeSelectController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlexpoolController from "./flexpool_controller"
application.register("flexpool", FlexpoolController)


import FormGuardController from "./form_guard_controller"
application.register("form-guard", FormGuardController)

import GenerationNavigationGuardController from "./generation_navigation_guard_controller"
application.register("generation-navigation-guard", GenerationNavigationGuardController)



import HeaderController from "./header_controller"
application.register("header", HeaderController)

import LegalAcceptanceController from "./legal_acceptance_controller"
application.register("legal-acceptance", LegalAcceptanceController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import I18nController from "./i18n_controller"
application.register("i18n", I18nController)


import ModalController from "./modal_controller"
application.register("modal", ModalController)


import MultiselectDropdownController from "./multiselect_dropdown_controller"
application.register("multiselect-dropdown", MultiselectDropdownController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OnboardingCostCalculatorController from "./onboarding_cost_calculator_controller"
application.register("onboarding-cost-calculator", OnboardingCostCalculatorController)

import OnboardingActivitiesController from "./onboarding_activities_controller"
application.register("onboarding-activities", OnboardingActivitiesController)

import OnboardingSpecialRequestsController from "./onboarding_special_requests_controller"
application.register("onboarding-special-requests", OnboardingSpecialRequestsController)

import OnboardingTeamMembersController from "./onboarding_team_members_controller"
application.register("onboarding-team-members", OnboardingTeamMembersController)

import OrReductionToggleController from "./or_reduction_toggle_controller"
application.register("or-reduction-toggle", OrReductionToggleController)

import PlanningCalendarController from "./planning_calendar_controller"
application.register("planning-calendar", PlanningCalendarController)

import PlanningGanttController from "./planning_gantt_controller"
application.register("planning-gantt", PlanningGanttController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import ProtectedDaysController from "./protected_days_controller"
application.register("protected-days", ProtectedDaysController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RuleCardController from "./rule_card_controller"
application.register("rule-card", RuleCardController)

import RotationSupervisorFilterController from "./rotation_supervisor_filter_controller"
application.register("rotation-supervisor-filter", RotationSupervisorFilterController)

import RoleEquivalencePairsController from "./role_equivalence_pairs_controller"
application.register("role-equivalence-pairs", RoleEquivalencePairsController)

import RoleSelectController from "./role_select_controller"
application.register("role-select", RoleSelectController)

import ShiftRolesController from "./shift_roles_controller"
application.register("shift-roles", ShiftRolesController)

import SolverProgressController from "./solver_progress_controller"
application.register("solver-progress", SolverProgressController)

import ShiftSwapController from "./shift_swap_controller"
application.register("shift-swap", ShiftSwapController)

import SlotRemovalController from "./slot_removal_controller"
application.register("slot-removal", SlotRemovalController)

import TeamMemberCountController from "./team_member_count_controller"
application.register("team-member-count", TeamMemberCountController)

import TestimonialSliderController from "./testimonial_slider_controller"
application.register("testimonial-slider", TestimonialSliderController)

import TimeCalculatorController from "./time_calculator_controller"
application.register("time-calculator", TimeCalculatorController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UnfilledSlotController from "./unfilled_slot_controller"
application.register("unfilled-slot", UnfilledSlotController)

import PreferenceCalendarController from "./preference_calendar_controller"
application.register("preference-calendar", PreferenceCalendarController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RosterDragController from "./roster_drag_controller"
application.register("roster-drag", RosterDragController)

import ScrollSyncController from "./scroll_sync_controller"
application.register("scroll-sync", ScrollSyncController)

import SubmitOnceController from "./submit_once_controller"
application.register("submit-once", SubmitOnceController)

import StaffPopoutController from "./staff_popout_controller"
application.register("staff-popout", StaffPopoutController)

import ValuePropsController from "./value_props_controller"
application.register("value-props", ValuePropsController)

import WeekStripController from "./week_strip_controller"
application.register("week-strip", WeekStripController)

import WizardActivitiesController from "./wizard_activities_controller"
application.register("wizard-activities", WizardActivitiesController)

import PlanningWizardController from "./planning_wizard/wizard_controller"
application.register("planning-wizard--wizard", PlanningWizardController)

import PlanningWizardEligibleDropdownController from "./planning_wizard/eligible_dropdown_controller"
application.register("planning-wizard--eligible-dropdown", PlanningWizardEligibleDropdownController)

import PlanningWizardGenerationProgressController from "./planning_wizard/generation_progress_controller"
application.register("planning-wizard--generation-progress", PlanningWizardGenerationProgressController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import NavigateSelectController from "./navigate_select_controller"
application.register("navigate-select", NavigateSelectController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineSaveController from "./inline_save_controller"
application.register("inline-save", InlineSaveController)

import PhaseGroupingController from "./phase_grouping_controller"
application.register("phase-grouping", PhaseGroupingController)

import RuleApplicabilityController from "./rule_applicability_controller"
application.register("rule-applicability", RuleApplicabilityController)

import ReductionCalendarController from "./reduction_calendar_controller"
application.register("reduction-calendar", ReductionCalendarController)

import DateSyncSubmitController from "./date_sync_submit_controller"
application.register("date-sync-submit", DateSyncSubmitController)

import RecurrenceController from "./recurrence_controller"
application.register("recurrence", RecurrenceController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import LeaveNudgeController from "./leave_nudge_controller"
application.register("leave-nudge", LeaveNudgeController)

import MemberSelectController from "./member_select_controller"
application.register("member-select", MemberSelectController)

import RangeDisplayController from "./range_display_controller"
application.register("range-display", RangeDisplayController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import DutyBlockPositionsController from "./duty_block_positions_controller"
application.register("duty-block-positions", DutyBlockPositionsController)

import LazyFrameOnToggleController from "./lazy_frame_on_toggle_controller"
application.register("lazy-frame-on-toggle", LazyFrameOnToggleController)

import ApModalController from "./ap_modal_controller"
application.register("ap-modal", ApModalController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import OnboardingMeetingsController from "./onboarding_meetings_controller"
application.register("onboarding-meetings", OnboardingMeetingsController)

import ShiftCategoryHintController from "./shift_category_hint_controller"
application.register("shift-category-hint", ShiftCategoryHintController)

import AnalyticsEventController from "./analytics_event_controller"
application.register("analytics-event", AnalyticsEventController)

import CalendlyPopupController from "./calendly_popup_controller"
application.register("calendly-popup", CalendlyPopupController)

import SelectOnClickController from "./select_on_click_controller"
application.register("select-on-click", SelectOnClickController)

import AvailabilityGridController from "./availability_grid_controller"
application.register("availability-grid", AvailabilityGridController)
